import React, { useEffect, useState, useRef } from "react";
import {useDispatch} from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/Experiences/actions";
import {
 AEDatePicker,
  AEInput,
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import {CONTEXT} from "../../../helpers/ModuleHelpers";
import {useIntl} from "react-intl";
import {actionTypes} from "../../../_redux/Experiences/slice";
import {HTTP_CREATED, HTTP_DELETED, HTTP_UPDATED} from "../../../../../../_emywork/helpers/AxiosHelpers";
import {useModuleContext} from "../../../ModuleContext";
import {AEButton} from "../../../../../../_emywork/components/buttons";
import {useFormik} from "formik";
import * as Yup from "yup";
import {localField} from "../../../../../../_emywork/helpers/UIHelper";


const validationSchema = Yup.object().shape({
  title: Yup.string().required(),
  description: Yup.string(),
  company: Yup.string(),
  started_at: Yup.string().required(),
  ended_at: Yup.string().nullable(),
});

export function ExperienceForm({entity, userId, getEntities}) {

  const {formatMessage} = useIntl();
  const dispatch = useDispatch();

  const { isLoading, validationErrors, entity: defaultEntity, authUser} = useSelector(state=> {
    const { isLoading, entity, validationErrors } = state.user_experiences[actionTypes.Edit];

    return {
      isLoading, entity, validationErrors,
      authUser: state.auth.user,
    }
  },shallowEqual)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: entity ? entity : defaultEntity,
    initialErrors: validationErrors,
    validationSchema,
    onSubmit: ({file_name, ...values})=>{

      if (!values.id) {
        values.user_id = userId;
        dispatch(actions.createEntity(values)).then((r) => {
          if(r.status === HTTP_CREATED){
            getEntities();
          }
        });
      } else {
        dispatch(actions.updateEntity(values)).then(r=>{
          if(r.status === HTTP_UPDATED){
            getEntities();
          }
        })
      }
    }
  });

  const { handleSubmit, getFieldProps, setFieldValue, values, setValues } = formik

  // Hooks

  useEffect(()=>{
    if(entity) setValues(entity)
  }, [entity])

  const deleteEntity = () => {
    dispatch(actions.deleteEntity(values.id)).then(r=>{
      if(r.status === HTTP_DELETED){
        getEntities();
      }
    })
  }


  const _props = (name, label, type)=>{
    let p = {
      name, label, type,
      field: getFieldProps(name),
      form: formik,
    };

    switch (type){
      case "autocomplete": {
        p.useId = true;
        p.getOptionLabel= o=>o[localField()]
      } break;
    }

    return p
  }


  return (
    <Card className={`card-border ${entity ? '' : 'border-5'}`}>
      <CardHeader title={entity ? formik.initialValues.title : formatMessage({id: "NEW"})}>
        <CardHeaderToolbar>
          {
            entity &&
            <AEButton
              variant={'light-primary'}
              className="ml-2"
              onClick={deleteEntity}
            >
              {formatMessage({id:'DELETE'})}
            </AEButton>
          }
          <AEButton
            variant={'primary'}
            className="ml-2"
            onClick={handleSubmit}
          >
            {formatMessage({id:'SAVE'})}
          </AEButton>

        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-2 col-form-label font-weight-bold">
            {formatMessage({id: 'TITLE'})}
          </label>
          <div className="col-lg-9 col-xl-6">
            <div className={'row'}>
              <div className={'col-lg-6'}>
                <AEInput
                  {..._props('title','TITLE')}
                />
              </div>
              <div className={'col-lg-6'}>
                <AEInput
                  {..._props('company','COMPANY')}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-2 col-form-label font-weight-bold">
            {formatMessage({id: 'DATE'})}
          </label>
          <div className="col-lg-9 col-xl-6">
            <div className={'row'}>
              <div className={'col-lg-6'}>
                <AEDatePicker
                  {..._props('started_at','STARTED_AT', 'date')}
                />
              </div>
              <div className={'col-lg-6'}>
                <AEDatePicker
                  {..._props('ended_at','ENDED_AT', 'date')}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-2 col-form-label font-weight-bold">
            {formatMessage({id: 'DESCRIPTION'})}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEInput
              {..._props('description','DESCRIPTION', 'textarea')}
              rows={5}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

